export const LANGUAGES = {
  EN: 'en',
  SV: 'sv',
  DE: 'de',
  NB: 'nb',
  IT: 'it',
  FR: 'fr',
  ES: 'es',
  DA: 'da',
};

export const LANGUAGES_NAMES = {
  [LANGUAGES.EN]: 'English',
  [LANGUAGES.SV]: 'Svenska',
  [LANGUAGES.DE]: 'Deutsch',
  [LANGUAGES.FR]: 'Français',
  [LANGUAGES.ES]: 'Español',
  [LANGUAGES.IT]: 'Italiano',
  [LANGUAGES.NB]: 'Norska (Bokmål)',
  [LANGUAGES.DA]: 'Danska',
};
